import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "antd/dist/antd.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import * as serviceWorker from "./serviceWorker";
import './i18n';
import dotenv from 'dotenv';

dotenv.config();
ReactDOM.render(<App />, document.getElementById("root"));
serviceWorker.unregister();
